/* eslint-disable */
import React, { PropTypes } from 'react';
// import _ from 'lodash';
import $ from 'jquery';
import { Modal, Button, Col, Row, Well, HelpBlock, FormControl, FormGroup, ControlLabel } from 'react-bootstrap';
// import { browserHistory } from 'react-router';
// import DatePicker from 'react-datepicker';
// import moment from 'moment';
// import Select, { Creatable } from 'react-select';

// import { TextField, SelectField, DatePickerInstance, TextAreaField, ReadOnlyField } from './OnlineRepairPs';
// import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
// import {onFileDrop, onFileDelete} from '../../../commonComponents/onFileModify';

export default class OnlineRepairDiscussCt extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			is_loading: true,
			data: [],
			is_data_loaded: false,
			comment: '',
			error_msg: false
		}

		// this.loadData = this.loadData.bind(this)
		// this.onSubmit = this.onSubmit.bind(this)
	}

	componentDidMount() {

		const { repair_id } = this.props.params

		this.loadData(repair_id)

		// const { route, params } = this.props

		//   route.type === 'add' ? this.setState({ enableEdit: true }) : this.loadData( params.id )
	}

	componentWillReceiveProps(nextProps) {

		// if ( nextProps.params.id !== this.props.params.id ) {

		// 	this.loadData(nextProps.params.id)
		// }
	}

	componentDidUpdate(prevProps, prevState) {
		const { is_loading, is_data_loaded } = this.state

		if (is_loading === true && is_data_loaded == true) {
			this.setState({ is_loading: false })
		}

		// const { is_company_data_loaded, company_data } = this.props
		// const { is_data_loaded, is_contact_data_loaded, contact } = this.state

		// if ( is_data_loaded && is_company_data_loaded && !is_contact_data_loaded ) {
		// 	this.setState({ is_contact_data_loaded: true })
		// }
	}

	loadData(repair_id) {

		$.ajax({
			type: 'get',
			url: `/api/M_SaleSky_Repair_Sky_Discuss_Get.php?repair_id=${repair_id}`,
			success: response => {
				if (response.status == 0) {
					this.setState({ data: response.result, is_data_loaded: true })
				} else if (response.status == '404') {
					this.setState({ data: [], is_data_loaded: true })
				} else {
					alert(response.msg)
					this.props.closeModal()
				}
			},
			error: (xhr, ajaxOptions, thrownError) => { },
		});
	}

	loadProductData(id) {

		// const { product_model } = this.state

		// $.ajax({
		//     type: 'get',
		//     url: '/api/M_SaleSky_ShippingRecord_Get.php?company_id=' + id,
		//     success: response => {
		//       this.setState({ product_data: response.result, product_model: null });
		//     },
		//     error: (xhr, ajaxOptions, thrownError) => { },
		//   });
	}

	onSubmit() {

		const { repair_id } = this.props.params
		const { comment } = this.state

		if (comment === '') {

			this.setState({ error_msg: true })
		}
		else {

			let formData = new FormData()
			formData.append('repair_id', repair_id)
			formData.append('discuss_content', comment)

			$.ajax({
				type: 'post',
				url: '/api/M_SaleSky_Repair_Sky_Discuss_Post.php',
				data: formData,
				processData: false,
				contentType: false,
				success: response => {
					if (response.status === '0') {
						this.loadData(repair_id)
						this.setState({ error_msg: false, comment: '' })
						this.props.reload()
					} else { alert(response.msg) }
					// if(response.status==="0"){
					//   this.setState({
					//     error_msg: false,
					//     // disableSave: true,
					//     // fileUploading: false
					//   });
					//   this.props.reload()

					//   if ( route.type === 'add' ) {

					//   	this.uploadFiles(response.result.id)
					//   	this.props.closeModal();
					//   }
					//   else if ( route.type === 'edit' ) {

					//   	this.uploadFiles(response.result.id)
					//   	this.deleteFiles(response.result.id)
					//   	this.setState({ enableEdit: false })
					//   }
					// }
					// else {
					//   alert( response.msg )
					// }
				},
				error: (xhr, ajaxOptions, thrownError) => { },
			})
		}
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const { closeModal } = this.props,
			{ data, is_loading, comment, error_msg } = this.state,
			loading = is_loading === true ? <div className="loading"><img role="presentation" src="/imgs/loading.gif" /></div> : null

		// let status = _.find( status_data, { id: status_id } )
		// let status_name = status === undefined ? '' : status.name
		// let title = route.type === 'add' ? '' : <div><font color='#337ab7'>View</font> Mode</div>
		// let btn_save = enableEdit ? <Button onClick={ ()=> this.onSubmit() }>儲存</Button> : <Button onClick={ ()=> this.setState({ enableEdit: true }) }>編輯</Button>
		// let btn_copy = route.type === 'add' ? '' : <Button onClick={closeModal} style={{ display: 'none' }}>複製</Button>
		// let btn_prev_page = route.type === 'add' ? '' : <Button className="btn_page" onClick={ ()=> this.onPageChange('prev') }>上一筆</Button>
		// let btn_next_page = route.type === 'add' ? '' : <Button className="btn_page" onClick={ ()=> this.onPageChange('next') }>下一筆</Button>

		return (
			<Modal
				show={true}
				bsSize="large"
				className="modal_online_repair"
				onHide={closeModal}
				keyboard={false}
				backdrop="static">
				<Modal.Header>
					<div style={{ fontSize: '22px' }}>{languageData['455'][languageCode]}</div>
					<Button onClick={closeModal}>{languageData['452'][languageCode]}</Button>
				</Modal.Header>
				<Modal.Body style={{ maxHeight: '600px', overflow: 'auto' }}>
					{loading}
					{
						data.length == 0
							? <div>{languageData['458'][languageCode]}</div>
							: data.map((x, y) => {
								return (
									<div key={y}>
										<Row>
											<Col sm={12}>
												<div><span>{x.user_name + ':'}</span><span style={{ float: 'right', color: 'darkgrey', fontSize: "0.7em" }}>{x.create_time}</span></div>
											</Col>
										</Row>
										<Row>
											<Col sm={12}>
												<FormGroup>
													<FormControl readOnly={true} value={x.discuss_content} componentClass="textarea" />
												</FormGroup>
											</Col>
										</Row>
									</div>
								)
							})
					}
				</Modal.Body>
				<Modal.Footer style={{ flexDirection: 'column' }}>
					<div style={{ display: 'flex', padding: '0' }}>
						<input onChange={(event) => this.setState({ comment: event.target.value })} value={comment} className="form-control" placeholder="Write comments here" style={{ marginBottom: '0' }} />
						<Button onClick={() => this.onSubmit()} style={{ margin: '0 0 0 10px' }}>{languageData['457'][languageCode]}</Button>
					</div>
					<div className={(error_msg && comment === '') ? 'content error' : 'content'} style={{ margin: '4px' }}><HelpBlock>{languageData['459'][languageCode]}</HelpBlock></div>
				</Modal.Footer>
			</Modal>
		);
	}
}





// WEBPACK FOOTER //
// ./src/salesky/routes/online_repair/OnlineRepairDiscussCt.jsx